import React from "react";

export const Route = ({ as: Component, ...props }) => {
  return (
    <div>
        <Component {...props} />
    </div>
  );
};
